webpackJsonp([16348261429499,247727303383287],{

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _SimpleLoginPage = __webpack_require__(151);
	
	var _SimpleLoginPage2 = _interopRequireDefault(_SimpleLoginPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'LoginPage',
	  components: {
	    LoginPage: _reactCore.LoginPage,
	    LoginForm: _reactCore.LoginForm
	  },
	  examples: [{ component: _SimpleLoginPage2.default, title: 'Simple LoginPage' }],
	  fullPageOnly: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _images;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pf_logo_color = __webpack_require__(14);
	
	var _pf_logo_color2 = _interopRequireDefault(_pf_logo_color);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Note: When using background-filter.svg, you must also include #image_overlay as the fragment identifier
	 */
	
	var images = (_images = {}, _images[_reactCore.BackgroundImageSrc.lg] = '/assets/images/pfbg_1200.jpg', _images[_reactCore.BackgroundImageSrc.sm] = '/assets/images/pfbg_768.jpg', _images[_reactCore.BackgroundImageSrc.sm2x] = '/assets/images/pfbg_768@2x.jpg', _images[_reactCore.BackgroundImageSrc.xs] = '/assets/images/pfbg_576.jpg', _images[_reactCore.BackgroundImageSrc.xs2x] = '/assets/images/pfbg_576@2x.jpg', _images[_reactCore.BackgroundImageSrc.filter] = '/assets/images/background-filter.svg#image_overlay', _images);
	
	var SimpleLoginPage = function (_React$Component) {
	  _inherits(SimpleLoginPage, _React$Component);
	
	  function SimpleLoginPage(props) {
	    _classCallCheck(this, SimpleLoginPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onDropDownToggle = function (isOpen) {
	      _this.setState({
	        isDropDownOpen: isOpen
	      });
	    };
	
	    _this.onDropDownSelect = function (event) {
	      _this.setState({
	        isDropDownOpen: !_this.state.isDropDownOpen
	      });
	    };
	
	    _this.handleUsernameChange = function (value) {
	      _this.setState({ usernameValue: value });
	    };
	
	    _this.handlePasswordChange = function (passwordValue) {
	      _this.setState({ passwordValue: passwordValue });
	    };
	
	    _this.onRememberMeClick = function () {
	      _this.setState({ isRememberMeChecked: !_this.state.isRememberMeChecked });
	    };
	
	    _this.state = {
	      isDropDownOpen: false,
	      usernameValue: '',
	      passwordValue: '',
	      isRememberMeChecked: false
	    };
	    return _this;
	  }
	
	  SimpleLoginPage.prototype.render = function render() {
	    var isDropDownOpen = this.state.isDropDownOpen;
	
	    var dropdownItems = [_react2.default.createElement(
	      _reactCore.DropdownItem,
	      { key: 'english' },
	      'English'
	    ), _react2.default.createElement(
	      _reactCore.DropdownItem,
	      { key: 'spanish' },
	      'Spanish'
	    )];
	    var languageDropdown = _react2.default.createElement(_reactCore.Dropdown, {
	      dropdownItems: dropdownItems,
	      onSelect: this.onDropDownSelect,
	      toggle: _react2.default.createElement(
	        _reactCore.DropdownToggle,
	        { onToggle: this.onDropDownToggle },
	        'English'
	      ),
	      isOpen: isDropDownOpen
	    });
	
	    var signUpMessage = _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      'Need an account? ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.patternfly.org' },
	        'Sign Up.'
	      )
	    );
	
	    var listItem = _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactCore.ListItem,
	        null,
	        _react2.default.createElement(
	          _reactCore.LoginFooterItem,
	          { href: '#' },
	          'Terms of Use '
	        )
	      ),
	      _react2.default.createElement(
	        _reactCore.ListItem,
	        null,
	        _react2.default.createElement(
	          _reactCore.LoginFooterItem,
	          { href: '#' },
	          'Help'
	        )
	      ),
	      _react2.default.createElement(
	        _reactCore.ListItem,
	        null,
	        _react2.default.createElement(
	          _reactCore.LoginFooterItem,
	          { href: '#' },
	          'Privacy Policy'
	        )
	      )
	    );
	
	    var loginForm = _react2.default.createElement(_reactCore.LoginForm, {
	      usernameLabel: 'Username',
	      usernameValue: this.state.usernameValue,
	      onChangeUsername: this.handleUsernameChange,
	      usernameHelperTextInvalid: 'Unknown Username',
	      isValidUsername: true,
	      passwordLabel: 'Password',
	      passwordValue: this.state.passwordValue,
	      onChangePassword: this.handlePasswordChange,
	      passwordHelperTextInvalid: 'Password Invalid',
	      isValidPassword: true,
	      rememberMeLabel: 'Keep me logged in for 30 days.',
	      isRememberMeChecked: this.state.isRememberMeChecked,
	      onChangeRememberMe: this.onRememberMeClick,
	      rememberMeAriaLabel: 'Remember me Checkbox'
	    });
	
	    return _react2.default.createElement(
	      _reactCore.LoginPage,
	      {
	        footerListVariants: 'inline',
	        brandImgSrc: _pf_logo_color2.default,
	        brandImgAlt: 'PatternFly logo',
	        backgroundImgSrc: images,
	        backgroundImgAlt: 'Images',
	        footerListItems: listItem,
	        textContent: 'This is placeholder text only. Use this area to place any information or introductory message about your application that may be relevant to users.',
	        loginTitle: 'Log in to your account',
	        signUpForAccountMessage: signUpMessage,
	        languageSelector: languageDropdown
	      },
	      loginForm
	    );
	  };
	
	  return SimpleLoginPage;
	}(_react2.default.Component);
	
	exports.default = SimpleLoginPage;
	SimpleLoginPage.__docgenInfo = {
	  'description': '',
	  'displayName': 'SimpleLoginPage'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport brandImg from './pf_logo_color.svg';\nimport {\n  Dropdown,\n  DropdownItem,\n  DropdownToggle,\n  LoginFooterItem,\n  LoginForm,\n  LoginPage,\n  BackgroundImageSrc,\n  ListItem\n} from '@patternfly/react-core';\n\n/**\n * Note: When using background-filter.svg, you must also include #image_overlay as the fragment identifier\n */\n\nconst images = {\n  [BackgroundImageSrc.lg]: '/assets/images/pfbg_1200.jpg',\n  [BackgroundImageSrc.sm]: '/assets/images/pfbg_768.jpg',\n  [BackgroundImageSrc.sm2x]: '/assets/images/pfbg_768@2x.jpg',\n  [BackgroundImageSrc.xs]: '/assets/images/pfbg_576.jpg',\n  [BackgroundImageSrc.xs2x]: '/assets/images/pfbg_576@2x.jpg',\n  [BackgroundImageSrc.filter]: '/assets/images/background-filter.svg#image_overlay'\n};\n\nclass SimpleLoginPage extends React.Component {\n  constructor(props) {\n    super(props);\n    this.state = {\n      isDropDownOpen: false,\n      usernameValue: '',\n      passwordValue: '',\n      isRememberMeChecked: false\n    };\n  }\n\n  onDropDownToggle = isOpen => {\n    this.setState({\n      isDropDownOpen: isOpen\n    });\n  };\n\n  onDropDownSelect = event => {\n    this.setState({\n      isDropDownOpen: !this.state.isDropDownOpen\n    });\n  };\n\n  handleUsernameChange = value => {\n    this.setState({ usernameValue: value });\n  };\n\n  handlePasswordChange = passwordValue => {\n    this.setState({ passwordValue });\n  };\n\n  onRememberMeClick = () => {\n    this.setState({ isRememberMeChecked: !this.state.isRememberMeChecked });\n  };\n\n  render() {\n    const { isDropDownOpen } = this.state;\n    const dropdownItems = [\n      <DropdownItem key=\"english\">English</DropdownItem>,\n      <DropdownItem key=\"spanish\">Spanish</DropdownItem>\n    ];\n    const languageDropdown = (\n      <Dropdown\n        dropdownItems={dropdownItems}\n        onSelect={this.onDropDownSelect}\n        toggle={<DropdownToggle onToggle={this.onDropDownToggle}>English</DropdownToggle>}\n        isOpen={isDropDownOpen}\n      />\n    );\n\n    const signUpMessage = (\n      <React.Fragment>\n        Need an account? <a href=\"https://www.patternfly.org\">Sign Up.</a>\n      </React.Fragment>\n    );\n\n    const listItem = (\n      <React.Fragment>\n        <ListItem>\n          <LoginFooterItem href=\"#\">Terms of Use </LoginFooterItem>\n        </ListItem>\n        <ListItem>\n          <LoginFooterItem href=\"#\">Help</LoginFooterItem>\n        </ListItem>\n        <ListItem>\n          <LoginFooterItem href=\"#\">Privacy Policy</LoginFooterItem>\n        </ListItem>\n      </React.Fragment>\n    );\n\n    const loginForm = (\n      <LoginForm\n        usernameLabel=\"Username\"\n        usernameValue={this.state.usernameValue}\n        onChangeUsername={this.handleUsernameChange}\n        usernameHelperTextInvalid=\"Unknown Username\"\n        isValidUsername\n        passwordLabel=\"Password\"\n        passwordValue={this.state.passwordValue}\n        onChangePassword={this.handlePasswordChange}\n        passwordHelperTextInvalid=\"Password Invalid\"\n        isValidPassword\n        rememberMeLabel=\"Keep me logged in for 30 days.\"\n        isRememberMeChecked={this.state.isRememberMeChecked}\n        onChangeRememberMe={this.onRememberMeClick}\n        rememberMeAriaLabel=\"Remember me Checkbox\"\n      />\n    );\n\n    return (\n      <LoginPage\n        footerListVariants=\"inline\"\n        brandImgSrc={brandImg}\n        brandImgAlt=\"PatternFly logo\"\n        backgroundImgSrc={images}\n        backgroundImgAlt=\"Images\"\n        footerListItems={listItem}\n        textContent=\"This is placeholder text only. Use this area to place any information or introductory message about your\n        application that may be relevant to users.\"\n        loginTitle=\"Log in to your account\"\n        signUpForAccountMessage={signUpMessage}\n        languageSelector={languageDropdown}\n      >\n        {loginForm}\n      </LoginPage>\n    );\n  }\n}\n\nexport default SimpleLoginPage;\n"

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.loginpage_package = exports.loginpage_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoginPageDocs = __webpack_require__(534);
	
	var _LoginPageDocs2 = _interopRequireDefault(_LoginPageDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'SimpleLoginPage', path: '../../react-core/src/components/LoginPage/examples/SimpleLoginPage.js', file: __webpack_require__(397) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var loginpage_docs = exports.loginpage_docs = _LoginPageDocs2.default;
	var loginpage_package = exports.loginpage_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _LoginPageDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-login-page-docs-js-d2f03a2d2d1c3d6c1cdc.js